import type { ReactNode } from "react";

const TOKEN = /(\[[^\]]+\]\([^)]+\)|\*\*[^*]+\*\*|`[^`]+`)/g;

function safeHref(href: string): boolean {
  return (href.startsWith("/") && !href.startsWith("//")) || /^https?:\/\//i.test(href);
}

/** Render the small, explicit inline Markdown subset used by calculator copy. */
export function renderInlineFinanceText(value: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let cursor = 0;
  for (const match of value.matchAll(TOKEN)) {
    const index = match.index ?? 0;
    if (index > cursor) nodes.push(value.slice(cursor, index));
    const token = match[0];
    const key = `inline-${index}`;

    if (token.startsWith("[")) {
      const parts = /^\[([^\]]+)\]\(([^)]+)\)$/.exec(token);
      if (parts && safeHref(parts[2])) {
        const external = /^https?:\/\//i.test(parts[2]);
        nodes.push(
          <a key={key} href={parts[2]} target={external ? "_blank" : undefined} rel={external ? "noopener noreferrer" : undefined} className="post-link">
            {parts[1]}
          </a>
        );
      } else {
        nodes.push(token);
      }
    } else if (token.startsWith("**")) {
      nodes.push(<strong key={key}>{token.slice(2, -2)}</strong>);
    } else {
      nodes.push(<code key={key} className="inline-code">{token.slice(1, -1)}</code>);
    }
    cursor = index + token.length;
  }
  if (cursor < value.length) nodes.push(value.slice(cursor));
  return nodes;
}
